<button mat-stroked-button (click)="onViewModeToggle()">
  <!-- div for class is necessary bc. mat-button will inject inner container-->
  @let viewMode = activeViewMode$ | async;
  <div class="layout-row place-center-center gap-sm">
    @switch (viewMode) {
      @case (ViewMode.LIVE) {
        <mat-icon [color]="'warn'" class="flex-auto"> fiber_manual_record </mat-icon>
      }
      @case (ViewMode.PREVIEW) {
        <mat-icon class="flex-auto"> cached </mat-icon>
      }
    }
    <span class="flex-auto">
      {{
        (viewMode === ViewMode.LIVE ? 'utilization.viewMode.LIVE' : 'utilization.viewMode.PREVIEW')
          | translate
      }}
    </span>
  </div>
</button>
